import { makeStyles } from '@mui/styles';
import home_background from 'src/assets/home_background.png';

const useStyles = makeStyles({
  '@keyframes slideUpFadeIn': {
    '0%': {
      transform: 'translateX(70px)', // Inicia desde abajo
    },
    '100%': {
      transform: 'translateX(0)', // Se mueve hacia su posición original
    },
  },
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(-100%)', // Empieza desde la derecha
    },
    '100%': {
      transform: 'translateX(0)', // Termina en su posición original
    },
  },
  carouselArrow: {
    position: 'absolute',
    top: '50%', // Centra verticalmente en el carrusel
    transform: 'translateY(-50%)', // Evita que queden desalineadas
    zIndex: 10, // Asegura que estén sobre el contenido
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    color: '#000',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  homeContainer: {
    textAlign: 'center',
    animation: '$slideIn 1s ease-out',
    padding: '1rem',
    color: '#fff',
    backgroundImage: `url(${home_background})`,
    backgroundSize: '70%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
  homeTitle: {
    margin: '0.5rem 0',
  },
  homeDescription: {
    marginBottom: '1.5rem',
  },
  showMoreButton: {
    padding: '1rem',
    color: '#fff',
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    borderRadius: '100px',
    cursor: 'pointer',
    marginBottom: '2rem',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000',
    },
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
  resultsText: {
    marginBottom: '2rem',
    '@media (max-width: 1200px)': {
    },
  },
  imagesContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    '@media (max-width: 1200px)': {
      flexWrap: 'wrap',
      gap: '1rem',
    },
  },
  largeImage: {
    width: '350px', // Ajusta el tamaño general de la imagen
    marginRight: '15px',
    marginLeft: '15px',
    objectFit: 'contain', // Asegura que la imagen llene el espacio manteniendo la proporción
    '@media (max-width: 1200px)': {
      width: '250px', // Cambia el tamaño relativo para pantallas más pequeñas
      height: 'auto', // Mantiene la proporción
      marginTop: '15px',
    },
  },
  kivitImage: {
    width: '250px', // Ajusta el tamaño general de la imagen
    marginRight: '15px',
    marginLeft: '15px',
    objectFit: 'contain', // Asegura que la imagen llene el espacio manteniendo la proporción
    '@media (max-width: 1200px)': {
      width: '150px', // Cambia el tamaño relativo para pantallas más pequeñas
      height: 'auto', // Mantiene la proporción
      marginTop: '15px',
    },
  },
  orkestaMediaImage: {
    width: '450px', // Ajusta el tamaño general de la imagen
    marginRight: '15px',
    marginLeft: '15px',
    objectFit: 'contain', // Asegura que la imagen llene el espacio manteniendo la proporción
    '@media (max-width: 1200px)': {
      width: '350px', // Cambia el tamaño relativo para pantallas más pequeñas
      height: 'auto', // Mantiene la proporción
      marginTop: '15px',
    },
  },
  homeSubtitle: {
    marginTop: '5rem',
    background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (max-width: 1200px)': {
      marginTop: '3rem',
    },
  },
  homeSubtitleDescription: {
    marginBottom: '3.5rem',
    '@media (max-width: 1200px)': {
      marginBottom: '2rem',
    },
  },
  carouselContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative', // Importante para que las flechas se posicionen dentro
    height: '700px',
    width: '100%',
    overflowX: 'hidden',
    '@media (max-width: 768px)': {
      height: '400px',
    },
  },
  carouselContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%', // Asegura que el contenido ocupe todo el ancho disponible
  },
  cardsContainer: {
    userSelect: 'none',
    display: 'flex',
    gap: '1rem',
    flexWrap: 'nowrap',
    scrollSnapType: 'x mandatory',
     // Cambiado de 'auto' a 'hidden' para que no se vea el overflow
    scrollBehavior: 'smooth',
    width: '80%', // Ajustamos el ancho para que solo entren 3 tarjetas
    justifyContent: 'center',
  
    '@media (max-width: 1200px)': {
      width: '90%', // Ajusta el ancho en pantallas más pequeñas
      gap: '0.5rem',
    },
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  card: {
    scrollSnapAlign: 'start',
    flexShrink: 0,
    width: 'calc(100% / 3 - 1rem)', // Divide el contenedor en tres tarjetas visibles
    textAlign: 'center',
    backgroundColor: 'transparent',
    color: '#fff',
    border: '2px solid #fff',
    borderRadius: '10px',
    padding: '1rem',
    boxShadow: '0 4px 6px rgba(255, 255, 255, 0.1)',
    animation: '$slideUpFadeIn 0.8s ease-out',
    '@media (max-width: 1200px)': {
      width: 'calc(100% / 3 - 0.5rem)', // Reduce el tamaño en pantallas más pequeñas
      padding: '0.8rem',
    },
    '@media (max-width: 768px)': {
      width: 'calc(100% / 2 - 0.5rem)', // En móviles solo se verán 2 tarjetas
      padding: '0.5rem',
    },
  },  
  cardImage: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    marginBottom: '1rem',
    '@media (max-width: 1200px)': {
      width: '80px', // Reduce el tamaño de la imagen en tablets
      height: '80px',
    },
    '@media (max-width: 768px)': {
      width: '50px', // Reduce el tamaño de la imagen en dispositivos móviles
      height: '50px',
      marginBottom: '0.5rem', // Reduce el margen inferior en dispositivos móviles
    },
  },
  cardTitle: {
    margin: '0.5rem 0',
    background: 'linear-gradient(126deg, rgba(0,168,232,1) 2%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (max-width: 768px)': {
      fontSize: '0.9rem', // Reduce el tamaño del título en dispositivos móviles
    },
  },
  cardDescription: {
    color: '#ddd',
    '@media (max-width: 768px)': {
      fontSize: '0.8rem', // Reduce el tamaño de la descripción en dispositivos móviles
    },
  },
});

export default useStyles;
